/* Calculadora de frete v2 — vanilla JS, sem dependencias.
   Contrato de config e DOM definido no plano 2026-05-21-calculo-frete.md */
(function () {
  'use strict';
  if (window.__cfCalc) return;
  window.__cfCalc = true;

  var TRUCK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
    '<rect x="3" y="7" width="18" height="13"/><path d="M3 11h18"/></svg>';

  var BAG_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
    '<path d="M6 2 4 6v13a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6l-2-4z"/>' +
    '<path d="M4 6h16"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';

  // ---------- helpers ----------
  function onlyDigits(s) { return String(s == null ? '' : s).replace(/\D/g, ''); }

  function maskCep(value) {
    var d = onlyDigits(value).slice(0, 8);
    return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  }

  function toNumber(v) {
    return Number(String(v == null ? '' : v).replace(',', '.')) || 0;
  }

  function money(v) {
    var n = Number(v) || 0;
    if (n <= 0) return 'Grátis';
    return 'R$ ' + n.toFixed(2).replace('.', ',');
  }

  function etaText(days) {
    if (!days) return '';
    return 'até ' + days + (String(days) === '1' ? ' dia útil' : ' dias úteis');
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = String(s == null ? '' : s);
    return d.innerHTML;
  }

  function parseList(raw) {
    return String(raw == null ? '' : raw)
      .split(/\r?\n/)
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function parseRenameMap(raw) {
    var map = [];
    parseList(raw).forEach(function (line) {
      var idx = line.indexOf('=');
      if (idx === -1) return;
      var from = line.slice(0, idx).trim().toLowerCase();
      var to = line.slice(idx + 1).trim();
      if (from && to) map.push([from, to]);
    });
    return map;
  }

  // monta o nome exibido a partir de transportadora + servico, sem repeticao
  function joinCarrierName(carrier, name) {
    carrier = (carrier || '').trim();
    name = (name || '').trim();
    if (!carrier) return name;
    if (!name) return carrier;
    var c = carrier.toLowerCase();
    var n = name.toLowerCase();
    // "Logistica Personalizada" e o rotulo generico da Frenet para contratos
    // personalizados (motoboy etc.); nesse caso o nome do servico ja basta
    if (c.indexOf('personalizad') !== -1) return name;
    // evita repeticao quando um texto ja contem o outro
    if (n.indexOf(c) !== -1) return name;
    if (c.indexOf(n) !== -1) return carrier;
    return carrier + ' ' + name;
  }

  // ---------- normalizacao das duas APIs para um formato unico ----------
  function normalizeME(data) {
    if (!Array.isArray(data)) return [];
    return data
      .filter(function (s) { return s && !s.error && s.price != null; })
      .map(function (s) {
        var carrier = (s.company && s.company.name ? s.company.name : '').trim();
        var name = (s.name || '').trim();
        return {
          carrier: carrier,
          name: name,
          label: joinCarrierName(carrier, name),
          days: s.delivery_time ? String(s.delivery_time) : '',
          price: toNumber(s.price),
          logo: (s.company && s.company.picture) ? s.company.picture : ''
        };
      });
  }

  function normalizeFrenet(data) {
    var arr = (data && (data.ShippingSevicesArray || data.ShippingServicesArray)) || [];
    if (!Array.isArray(arr)) return [];
    return arr
      .filter(function (s) { return s && !s.Error; })
      .map(function (s) {
        var carrier = (s.Carrier || '').trim();
        var name = (s.ServiceDescription || '').trim();
        var raw = (s.PresentationalPrice != null ? s.PresentationalPrice : s.ShippingPrice);
        return {
          carrier: carrier,
          name: name,
          label: joinCarrierName(carrier, name),
          days: s.DeliveryTime ? String(s.DeliveryTime) : '',
          price: toNumber(raw),
          logo: ''
        };
      });
  }

  // ---------- filtros: ocultar -> dedup -> markup -> renomear -> ordenar ----------
  function applyFilters(list, cfg) {
    var hide = parseList(cfg.hideCarriers).map(function (s) { return s.toLowerCase(); });
    var renames = parseRenameMap(cfg.renameCarriers);
    var fixed = toNumber(cfg.surchargeFixed);
    var percent = toNumber(cfg.surchargePercent);

    var out = list.filter(function (item) {
      var hay = (item.carrier + ' ' + item.name).toLowerCase();
      return !hide.some(function (h) { return h && hay.indexOf(h) !== -1; });
    });

    if (cfg.dedupe) {
      var seen = {};
      out = out.filter(function (item) {
        var sig = (item.carrier + ' ' + item.name).toLowerCase().replace(/\s+/g, ' ').trim() +
          '|' + item.days + '|' + Math.round(item.price);
        if (seen[sig]) return false;
        seen[sig] = true;
        return true;
      });
    }

    if (fixed || percent) {
      out.forEach(function (item) {
        item.price = Number(Math.max(0, (item.price + fixed) * (1 + percent / 100)).toFixed(2));
      });
    }

    out.forEach(function (item) {
      var key = (item.carrier + ' ' + item.name).toLowerCase();
      renames.forEach(function (pair) {
        if (key.indexOf(pair[0]) !== -1) item.label = pair[1];
      });
    });

    out.sort(function (a, b) { return a.price - b.price; });
    return out;
  }

  // ---------- payloads ----------
  function mePayload(cfg, cep, insurance) {
    return {
      from: { postal_code: cfg.originCep },
      to: { postal_code: cep },
      products: [{
        id: 'x',
        width: cfg.dimensions.widthCm,
        height: cfg.dimensions.heightCm,
        length: cfg.dimensions.lengthCm,
        weight: cfg.weightKg,
        insurance_value: insurance,
        quantity: 1
      }]
    };
  }

  function frenetPayload(cfg, cep, insurance) {
    return {
      SellerCEP: cfg.originCep,
      RecipientCEP: cep,
      ShipmentInvoiceValue: insurance,
      ShippingServiceCode: null,
      ShippingItemArray: [{
        Height: cfg.dimensions.heightCm,
        Length: cfg.dimensions.lengthCm,
        Quantity: 1,
        Weight: cfg.weightKg,
        Width: cfg.dimensions.widthCm,
        SKU: cfg.sku,
        Category: 'Default'
      }],
      RecipientCountry: 'BR'
    };
  }

  function quote(url, payload) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 15000);
    function clearTimer(result) { clearTimeout(timer); return result; }
    function clearTimerThrow(err) { clearTimeout(timer); throw err; }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: controller.signal
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(clearTimer, clearTimerThrow);
  }

  // valor do pedido: subtotal do carrinho se houver itens, senao o preco do produto
  function getOrderValue(cfg) {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && typeof cart.total_price === 'number' && cart.total_price > 0) {
          return cart.total_price / 100;
        }
        return cfg.productPriceReais || 0;
      })
      .catch(function () { return cfg.productPriceReais || 0; });
  }

  // ---------- estados de tela ----------
  function showLoading(els) {
    els.results.innerHTML =
      '<div class="cf__loading"><span class="cf__spinner"></span>Calculando frete...</div>';
  }

  function showMessage(els, text, isError) {
    els.results.innerHTML =
      '<div class="cf__msg' + (isError ? ' cf__msg--error' : '') + '">' + escapeHtml(text) + '</div>';
  }

  // rows: itens com kind 'pickup' | 'free' | 'paid'. O destaque vai para o frete
  // gratis (se houver) ou para o mais barato pago; retirada nunca leva destaque.
  function render(els, rows) {
    els.results.innerHTML = '';
    var paid = rows.filter(function (r) { return r.kind === 'paid'; });
    var hasFree = rows.some(function (r) { return r.kind === 'free'; });
    var cheapestPaid = (!hasFree && paid.length > 1) ? paid[0] : null;
    rows.forEach(function (item) {
      var isBest = item.kind === 'free' || item === cheapestPaid;
      var row = document.createElement('div');
      row.className = 'cf__row' + (isBest ? ' cf__row--best' : '');
      var icon = item.kind === 'pickup'
        ? BAG_SVG
        : (item.logo ? '<img src="' + escapeHtml(item.logo) + '" alt="">' : TRUCK_SVG);
      var tag = (item === cheapestPaid) ? '<span class="cf__tag">Menor preço</span>' : '';
      var etaStr = (item.eta != null) ? item.eta : (item.days ? etaText(item.days) : '');
      var eta = etaStr ? '<span class="cf__eta">' + escapeHtml(etaStr) + '</span>' : '';
      row.innerHTML =
        '<span class="cf__icon">' + icon + '</span>' +
        '<span class="cf__info">' +
          '<span class="cf__name">' + escapeHtml(item.label) + tag + '</span>' + eta +
        '</span>' +
        '<span class="cf__price">' + money(item.price) + '</span>';
      els.results.appendChild(row);
    });
  }

  // ---------- fluxo principal ----------
  function calculate(cfg, els) {
    var cep = onlyDigits(els.input.value);
    if (cep.length !== 8) return;

    els.button.disabled = true;
    els.location.hidden = true;
    showLoading(els);

    getOrderValue(cfg).then(function (orderValue) {
      var insurance = cfg.enableInsurance ? orderValue : 0;
      var jobs = [];
      if (cfg.useME) {
        jobs.push(
          quote(cfg.workerUrl + '/melhorenvio/calculate', mePayload(cfg, cep, insurance))
            .then(normalizeME).catch(function () { return null; })
        );
      }
      if (cfg.useFR) {
        jobs.push(
          quote(cfg.workerUrl + '/frenet/quote', frenetPayload(cfg, cep, insurance))
            .then(normalizeFrenet).catch(function () { return null; })
        );
      }

      if (!jobs.length) {
        els.button.disabled = false;
        showMessage(els, 'Calculadora de frete sem transportadora configurada.', true);
        return;
      }

      Promise.all(jobs).then(function (resultsArr) {
        els.button.disabled = false;
        var anyError = resultsArr.some(function (r) { return r === null; });
        var combined = [];
        resultsArr.forEach(function (r) { if (r) combined = combined.concat(r); });

        var finalList = applyFilters(combined, cfg);

        if (!finalList.length && anyError) {
          showMessage(els, 'Não foi possível calcular o frete agora. Tente novamente.', true);
          return;
        }
        if (!finalList.length && !cfg.showPickup) {
          showMessage(els, 'No momento este produto não pode ser entregue na região informada.', false);
          return;
        }

        var rows = [];
        if (cfg.showPickup) {
          rows.push({
            kind: 'pickup',
            label: cfg.pickupLabel || 'Retirar na loja',
            eta: cfg.pickupEta || '',
            price: 0
          });
        }
        var threshold = toNumber(cfg.freeShippingThreshold);
        if (threshold > 0 && orderValue >= threshold && finalList.length) {
          rows.push({ kind: 'free', label: 'Frete Grátis', eta: '', price: 0 });
        }
        finalList.forEach(function (item) { item.kind = 'paid'; rows.push(item); });

        render(els, rows);
        els.locationText.textContent = 'Entregar em ' + maskCep(cep);
        els.location.hidden = false;
      });
    }).catch(function () {
      els.button.disabled = false;
      showMessage(els, 'Não foi possível calcular o frete agora. Tente novamente.', true);
    });
  }

  // ---------- init escopado por instancia ----------
  function init(root) {
    if (root.dataset.cfInit) return;
    var configEl = root.querySelector('[data-shipping-config]');
    if (!configEl) return;
    var cfg;
    try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }

    var els = {
      input: root.querySelector('[data-cep-input]'),
      button: root.querySelector('[data-cep-button]'),
      results: root.querySelector('[data-results]'),
      location: root.querySelector('[data-location]'),
      locationText: root.querySelector('[data-location-text]')
    };
    if (!els.input || !els.button || !els.results || !els.location || !els.locationText) return;

    // coercao defensiva de tipos
    cfg.dimensions = cfg.dimensions || {};
    cfg.dimensions.lengthCm = Number(cfg.dimensions.lengthCm) || 28;
    cfg.dimensions.widthCm = Number(cfg.dimensions.widthCm) || 18;
    cfg.dimensions.heightCm = Number(cfg.dimensions.heightCm) || 9;
    cfg.weightKg = Number(cfg.weightKg) || 0.5;
    cfg.originCep = onlyDigits(cfg.originCep);

    root.dataset.cfInit = '1';

    els.input.addEventListener('input', function () {
      els.input.value = maskCep(els.input.value);
    });
    els.button.addEventListener('click', function () { calculate(cfg, els); });
    els.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); calculate(cfg, els); }
    });
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-shipping-calculator]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
